// Copyright 2021 Sorama B.V.

import { DialogController } from "aurelia-dialog";
import { autoinject } from "aurelia-framework";
import { MeasurementRepository } from "repositories/MeasurementRepository";
import { MeasurementCollectionService } from "services/Measurement/MeasurementCollectionService";
import { Measurement } from "services/Measurement/MeasurementTypes";
import { IRecordingGroupContainerStorageService } from "services/Storage/IRecordingGroupContainerStorageService";

@autoinject
export class NewProjectDialog {
    private measurement: Measurement;
    private name: string;
    private notes: string;
    private distance: number;

    constructor(
        private readonly controller: DialogController,
        private readonly measurementCollectionService: MeasurementCollectionService,
        private readonly measurementRepository: MeasurementRepository,
        private readonly recordingGroupContainerStorageService: IRecordingGroupContainerStorageService
    ) {}

    public activate(measurementId: string) {
        this.measurement = this.measurementCollectionService.measurements.find((m) => m.id === measurementId);
        this.name = this.measurement.name;
        this.notes = this.measurement.notes;
        this.distance = this.measurement.distance;
    }

    protected cancel(): void {
        this.controller.cancel();
    }

    protected async submit(): Promise<void> {
        const propertyChangePromises = [];
        if (this.name || this.name === "") propertyChangePromises.push(this.measurement.setProperty("name", this.name));
        if (this.notes || this.notes === "")
            propertyChangePromises.push(this.measurement.setProperty("notes", this.notes));
        if (this.distance) propertyChangePromises.push(this.measurement.setProperty("distance", this.distance));
        await Promise.all(propertyChangePromises);
        this.controller.ok();
    }
}
